export const CorsType = {
  ANONYMOUS: 'anonymous',
  USE_CREDENTIALS: 'use-credentials'
} as const;
